import React, { useState, useEffect } from "react";
import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";
import { mobileBreakpoint } from "@src/../entrypoints/theme";

import AccountForm from "../AccountForm";
import useUrlContains from "@src/hooks/useUrlContains";

export const Default = ({ settings }) => {
    const [isLogin, setIsLogin] = useState(false);
    const [showBusinessFields, setShowBusinessFields] = useState(false);
    const isLoginPage = useUrlContains("account/login");
    const isAccountForgotPassword = useUrlContains("account/invalid_token");
    const showTitle = false;
    
    useEffect(() => {
        setIsLogin(isLoginPage);
    }, [isLoginPage]);

    const handleBusinessCheckbox = (isChecked) => {
        setShowBusinessFields(isChecked);
    };

    return (
        <div className="flex flex-col items-center justify-center account-page">
            <div className="w-full space-y-8 account-page__container">
                <div className="flex flex-col w-full gap-8 account-page__wrapper md:flex-row">
                    {/* Left Side (Form Section) */}
                    <div className="account-page__form-container w-full mx-auto space-y-[24px] justify-center items-center">
                        {showTitle && <h2 className={`flex w-full items-center justify-center`}>{isLogin ? 'Log In' : 'Register'}</h2>}
                        <AccountForm
                            settings={settings}
                            isLogin={isLogin}
                            isAccountForgotPassword={isAccountForgotPassword}
                            showBusinessFields={showBusinessFields}
                            handleBusinessCheckbox={handleBusinessCheckbox}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Default;
